<template>
  <div>
    <Card>
      <Form ref:form-inline
            inline>
        <Form-item>
          <Button type="info"
                  @click="add">{{$t('pages_banners_index_178')}}</Button>
        </Form-item>
        <Form-item>
          <Upload :on-success="handleSuccess"
                  :action="uploadUrl"
                  :headers="headers">
            <Button icon="ios-cloud-upload-outline">{{$t('pages_products_index_840')}}</Button>
          </Upload>
        </Form-item>
        <Form-item>
          <a href="https://fresh-picture.chengbao68.com/fresh_templet2.xlsx"
             download>
            <Button>{{$t('pages_products_index_841')}}</Button>
          </a>
        </Form-item>
      </Form>
      <div class="filter-container">
        <el-input clearable
                  @keyup.enter.native="searchBtnClick"
                  style="width: 200px;"
                  class="filter-item"
                  :placeholder="$t('pages_bookings_detail_222')"
                  v-model="searchData.query" />
        <el-select v-model="searchData.fresh_category_id" class="filter-item" clearable>
          <el-option v-for="category in all_categories" :key="category.id" :label="category.name" :value="category.id" />
        </el-select>
        <el-button size="medium"
                   class="filter-item"
                   style="margin-left: 10px;"
                   type="primary"
                   icon="el-icon-search"
                   @click="searchBtnClick()">{{$t('pages_bills_index_196')}}</el-button>
        <el-button size="medium"
                   class="filter-item"
                   style="margin-left: 10px;"
                   :loading="exportLoading"
                   @click="exportData"
                   type="danger"
                   icon="el-icon-download">{{ exportLoading ? $t('pages_products_index_842') : $t('pages_products_index_843') }}</el-button>
        <el-button size="medium"
                   class="filter-item"
                   style="margin-left: 10px;"
                   @click="exportChuanChengData"
                   type="success"
                   icon="el-icon-download"
                   >{{$t('pages_products_index_844')}}</el-button>{{$t('pages_products_index_845')}}<i-switch size="large" @on-change="(val) => {change_batch_product_display(val, 'wechat_mini')}" :value="wechat_mini_product_display">
            <span slot="open">{{$t('libs_table_render_50')}}</span>
            <span slot="close">{{$t('directives_index_41')}}</span>
        </i-switch>{{$t('pages_products_index_846')}}<i-switch size="large" @on-change="(val) => {change_batch_product_display(val, 'front')}" :value="front_product_display">
            <span slot="open">{{$t('libs_table_render_50')}}</span>
            <span slot="close">{{$t('directives_index_41')}}</span>
        </i-switch>
      </div>
      <Table style="margin-top: 20px;"
             ref="table"
             border
             :loading="loading"
             :columns="columns"
             :data="products">
        <template slot="sku"
                  slot-scope="{ row }">
          <router-link :to="`/products/${row.id}/edit`">
            <Tag :color="row.mall_skus && row.mall_skus.length ? 'green' : 'blue'">{{ row.mall_skus && row.mall_skus.length ? `${row.mall_skus && row.mall_skus.length}个sku` :'暂未设置' }}</Tag>
          </router-link>
        </template>
        <template slot="category"
                  slot-scope="{ row }">{{ row.fresh_category && row.fresh_category.name }}</template>
      </Table>
      <Row>
        <Page style="margin-top: 20px;"
              show-total
              :total="meta.total"
              :current="meta.current"
              :page-size="meta.pageSize"
              @on-change="changePage"></Page>
      </Row>
    </Card>
    <!-- <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           title="新增产品">
      <Form ref="product"
            :model="product"
            :label-width="120"
            :rules="ruleProduct">
        <Form-item label="名称"
                   prop="name">
          <Input type="text"
                 v-model="product.name" />
        </Form-item>
        <Form-item label="商品分类"
                   prop="category">
          <Select v-model="product.fresh_category_id"
                  style="width: 120px;"
                  :label="product.fresh_category_name"
                  placeholder="商品分类">
            <Option v-for="(cat, index) in all_categories"
                    :value="cat.id"
                    :key="index">{{ cat.name }}</Option>
          </Select>
        </Form-item>
        <Form-item label="商品单位"
                   prop="unit">
          <Select v-model="product.unit"
                  style="width: 120px;"
                  placeholder="商品单位">
            <Option v-for="(cat, index) in units"
                    :value="cat.name"
                    :key="index">{{ cat.name }}</Option>
          </Select>
        </Form-item>
        <Form-item label="商品条码"
                   prop="bar_code">
          <Input type="text"
                 v-model="product.bar_code" />
        </Form-item>
        <Form-item label="零售价"
                   prop="lingshoujia">
          <Input type="number"
                 v-model="product.lingshoujia" />
        </Form-item>
        <Form-item label="会员价"
                   prop="huiyuanjia">
          <Input type="number"
                 v-model="product.huiyuanjia" />
        </Form-item>
        <Form-item label="进货价"
                   prop="jinghuojia">
          <Input type="number"
                 v-model="product.jinghuojia" />
        </Form-item>
        <Form-item label="供应商"
                   prop="supplier">
          <Select v-model="product.fresh_supplier_id"
                  style="width: 120px;"
                  :label="product.fresh_supplier_name"
                  placeholder="选择供应商">
            <Option v-for="(cat, index) in all_suppliers"
                    :value="cat.id"
                    :key="index">{{ cat.name }}</Option>
          </Select>
        </Form-item>
        <Form-item label="展示"
                   prop="is_display">
          <i-switch size="large"
                    v-model="product.is_display">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </Form-item>
        <Form-item label="推荐商品"
                   prop="is_recommend">
          <i-switch size="large"
                    v-model="product.is_recommend">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </Form-item>
        <Form-item label="是否开启积分"
                   prop="score_open">
          <i-switch size="large"
                    v-model="product.score_open">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </Form-item>
        <Form-item label="是否启用打折"
                   prop="discount">
          <i-switch size="large"
                    v-model="product.discount">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </Form-item>
        <Form-item label="是否为称重商品"
                   prop="need_to_weight">
          <i-switch size="large"
                    v-model="product.need_to_weight">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </Form-item>
        <Form-item label="是否为捆绑商品"
                   prop="is_binding">
          <i-switch size="large"
                    v-model="product.is_binding">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </Form-item>
        <Form-item label="库存"
                   prop="stocks">
          <Input type="number"
                 v-model="product.stocks" />
        </Form-item>
        <Form-item label="图片"
                   prop="image">
          <uploader @uploadedUrl="uploadedUrl"
                    :url="product.image"></uploader>
        </Form-item>
        <Form-item label="规格型号"
                   prop="specs">
          <Input type="text"
                 v-model="product.specs" />
        </Form-item>
        <Form-item label="商品产地"
                   prop="address">
          <Input type="text"
                 v-model="product.address" />
        </Form-item>
        <Form-item label="是否合格"
                   prop="is_valid">
          <i-switch size="large"
                    v-model="product.is_valid">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </Form-item>
        <Form-item label="检测报告"
                   prop="check_report">
          <Input type="text"
                 v-model="product.check_report" />
        </Form-item>
        <Form-item label="检测项"
                   prop="check_item">
          <Input type="text"
                 v-model="product.check_item" />
        </Form-item>
      </Form>
    </Modal> -->
    <!-- 导出的表格 -->
    <table ref="chuanchengTable"
           style="display: none">
      <tr v-for="(item, index) in chuanChengData"
          :key="index">
        <td v-for="field in chuanchengFields"
            :key="field">{{ item[field] }}</td>
      </tr>
    </table>
    <table ref="exportTable"
           style="display: none">
      <thead>
        <tr>
          <th v-for="item in exportFields"
              :key="item.key">{{ item.title }}</th>
        </tr>
      </thead>
      <tr v-for="(item, index) in products_all"
          :key="index">
        <td v-for="(field, index) in exportFields"
            :key="index">{{ getExportColumnData(item, field) }}</td>
      </tr>
    </table>
    <sync-data-shop ref="syncDataShop" @sync="syncToSubShop" />
    <sync-data-shops ref="syncDataShops" @sync="syncToSubShops" />
  </div>
</template>

<script>
import i18n from '../../locales/index'

/* eslint-disable */
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Uploader from '@/components/uploader-aliyun/single'
import axios from 'axios';
import {
  syncButtonInTable,
  syncShopsButtonInTable,
  deleteButtonInTable,
  // editorButtonInTable,
  tableAvatar,
  booleanChinese
} from '@/libs/table-render'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import _ from 'lodash';
import SyncDataShop from '@/components/sync-data-shop/index'
import SyncDataShops from '@/components/sync-data-shop/multiple'

const chuanchengFields = [
  'lfcode',
  'code',
  'barcode',
  'dept',
  'groupid',
  'name1',
  'name2',
  'price',
  'orgprice',
  'packagetype',
  'barcode1',
  'barcode2',
  'packagedate',
  'vailddate',
  'SaleDate',
  'packagetime',
  'SaleTime',
  'label1',
  'label2',
  'unitweight',
  'Overprice',
  'Ingredients',
  'OtherMsg',
  'Tracemsg',
  'Discount',
  'tareweight',
  'icetbl',
  'tax1',
  'tax2',
  'tax3',
  'tax4',
  'limtMaxPrice',
  'PrintVaildDate',
  'PrintPackageDate',
  'PrintPackageTime',
  'PrintSaleDate',
  'PrintSaleTime',
  'overdiscount',
  'fixWeight',
  'tareidx',
  'tarechk',
  'FixPrice'
]

const exportFields = [
  {
    title: i18n.t('pages_bookings_detail_222'),
    key: 'name',
  },
  {
    title: i18n.t('pages_booking_store_products_index_220'),
    key: 'fresh_category.name',
  },
  {
    title: i18n.t('pages_products_components_sku_edit_form_774'),
    key: 'jinghuojia'
  },
  {
    title: i18n.t('pages_ai_thirdparty_166'),
    key: 'lingshoujia',
  },
  {
    title: i18n.t('pages_ai_thirdparty_167'),
    key: 'huiyuanjia',
  },
  {
    title: i18n.t('pages_orders_index_635'),
    key: 'specs',
  },
  {
    title: i18n.t('pages_product_stocks_index_740'),
    key: 'stocks',
  },
  {
    title: i18n.t('pages_products_index_848'),
    key: 'bar_code',
  },
  {
    title: i18n.t('pages_ai_thirdparty_168'),
    key: 'need_to_weight',
    render (need) {
      return need ? '是' : i18n.t('directives_index_41')
    }
  },
  {
    title: i18n.t('pages_products_index_849'),
    key: 'score_open',
    render (open) {
      return open ? '是' : i18n.t('directives_index_41')
    }
  },
  {
    title: i18n.t('pages_booking_store_products_index_221'),
    key: 'unit',
  },
  {
    title: i18n.t('pages_bookings_index_229'),
    key: 'fresh_supplier.name'
  },
  {
    title: i18n.t('pages_products_index_850'),
    key: 'fresh_supplier.username'
  },
  {
    title: i18n.t('pages_products_index_851'),
    key: 'fresh_supplier.telephone'
  }
];
export default {
  components: {
    Uploader,
    SyncDataShop,
    SyncDataShops
  },
  data () {
    return {
      headers: {
        Authorization: Cookies.get(TOKEN_KEY),
        ShopId: localStorage.getItem('SHOPID')
      },
      uploadUrl: `${process.env.VUE_APP_API_HOST}/products/upload`,
      query: '',
      searchData: {
        id: undefined,
        fresh_category_id: null
      },
      modalShow: false,
      formType: '',
      ruleProduct: {
        name: [{ required: true, message: i18n.t('pages_booking_store_products_index_216'), trigger: 'blur' }],
        lingshoujia: [{ required: true, message: i18n.t('pages_products_components_sku_edit_form_786'), trigger: 'blur' }],
        category: [{ required: true, message: i18n.t('pages_booking_store_products_index_217'), trigger: 'blur' }],
        unit: [{ required: true, message: i18n.t('pages_booking_store_products_index_218'), trigger: 'blur' }]
      },
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_165'),
          key: 'image',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return tableAvatar(h, params.row.image)
          }
        },
        {
          title: i18n.t('pages_ai_image_158'),
          key: 'name',
          width: 160,
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_174'),
          key: 'summary',
          width: 160,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_index_852'),
          key: 'mall_skus',
          width: 120,
          slot: 'sku'
        },
        {
          title: i18n.t('pages_booking_store_products_index_221'),
          key: 'unit',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_166'),
          key: 'lingshoujia',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_index_853'),
          key: 'wechat_lingshoujia',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_167'),
          key: 'huiyuanjia',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_index_854'),
          key: 'wechat_huiyuanjia',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_components_sku_edit_form_774'),
          key: 'jinghuojia',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_product_stocks_index_740'),
          key: 'stocks',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_booking_store_products_index_220'),
          key: 'fresh_category',
          width: 120,
          align: 'center',
          slot: 'category'
        },
        {
          title: i18n.t('pages_orders_index_635'),
          key: 'specs',
          width: 150,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_index_848'),
          key: 'bar_code',
          width: 200,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_index_855'),
          key: 'easy_code',
          width: 120,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_index_856'),
          key: 'code',
          width: 120,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_168'),
          key: 'need_to_weight',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.need_to_weight)
          }
        },
        {
          title: i18n.t('pages_products_index_857'),
          key: 'is_binding',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.is_binding)
          }
        },
        {
          title: i18n.t('pages_ai_thirdparty_169'),
          key: 'is_display',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.is_display)
          }
        },
        {
          title: i18n.t('pages_ai_thirdparty_170'),
          key: 'discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.discount)
          }
        },
        {
          title: i18n.t('pages_products_index_858'),
          key: 'score_open',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.score_open)
          }
        },
        {
          title: i18n.t('pages_products_edit_811'),
          key: 'address',
          width: 120,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_index_859'),
          key: 'is_valid',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_edit_813'),
          key: 'check_report',
          width: 120,
          align: 'center'
        },
        {
          title: i18n.t('pages_products_edit_814'),
          key: 'check_item',
          width: 120,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 180,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const onclick = () => {
              this.$router.push(`/products/${params.row.id}/edit`)
              // const jump = this.$router.resolve()
              // window.open(jump.href, '_blank')
            }
            const children = []
            children.push(h('Button', { on: { click: onclick }, props: { type: 'primary' } }, i18n.t('libs_table_render_71')));
            children.push(deleteButtonInTable(this, h, params))
            if (localStorage.getItem('IS_CLONED_MAIN_SHOP') === '1') {
              // children.push(syncButtonInTable(this, h, params))
              children.push(syncShopsButtonInTable(this, h, params))
            }
            return h('div', children)
          }
        }
      ],
      chuanChengData: [],
      chuanchengFields: chuanchengFields,
      exportFields,
      exportLoading: false,
    }
  },
  mounted () {},
  created () {
    this.resetQuery()
    this.index({ is_display: 'ignore' })
    this.allCategory({})
    this.allSuppliers({})
    this.unit_index({ per: 100 })
  },
  computed: {
    ...mapGetters('product', ['product', 'products', 'products_all', 'meta', 'loading', 'wechat_mini_product_display', 'front_product_display']),
    ...mapGetters('category', ['all_categories']),
    ...mapGetters('supplier', ['all_suppliers']),
    ...mapGetters('unit', ['units'])
  },
  methods: {
    ...mapActions('product', {
      clear: 'clear',
      index: 'index',
      index_all: 'index_all',
      show: 'show',
      create: 'create',
      destroy_all: 'destroy_all',
      update: 'update',
      destroy: 'destroy',
      action_batch_product_display: 'batch_product_display',
      syncToSubShop:'syncToSubShop',
      syncToSubShops:'syncToSubShops'
    }),
    ...mapActions('category', ['allCategory']),
    ...mapActions('supplier', ['allSuppliers']),
    ...mapActions('unit', { unit_index: 'index' }),
    ...mapMutations('product', ['changeQuery', 'resetQuery', 'targetSyncId']),
    change_batch_product_display (value, platform) {
      this.action_batch_product_display({
        platform,
        open: value
      })
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index({ is_display: 'ignore' })
    },
    uploadedUrl (url) {
      this.product.image = url
    },
    check_stock (id) {
      this.$router.push(`/products/${id}/stocks`)
    },
    add () {
      this.clear()
      // this.modalShow = true
      // this.formType = 'new'
      this.$router.push('/products/new/edit')
    },
    destroy_total () {
      this.destroy_all()
    },
    handleSubmit () {
      if (this.formType === 'edit') {
        this.update(this.product)
      } else if (this.formType === 'new') {
        this.create(this.product)
      }
      this.modalShow = false
    },
    handleSuccess (res, file) {
      this.$Message.success(i18n.t('pages_customers_index_345'))
    },
    searchBtnClick () {
      if (!this.searchData.fresh_category_id) this.searchData.fresh_category_id = null
      this.resetQuery()
      this.changeQuery(this.searchData)
      this.index()
    },
    async exportData () {
      this.exportLoading = true;
      await this.index_all({ per: 1000 })
      // this.$refs.table.exportCsv({
      //   // quoted: true,
      //   // separator: ',=',
      //   // original: false,
      //   columns: this.columns,
      //   data: this.products_all,
      //   filename: '商品信息'
      // })
      const book = XLSX.utils.book_new();
      const s1 = XLSX.utils.table_to_sheet(this.$refs.exportTable);
      XLSX.utils.book_append_sheet(book, s1, i18n.t('pages_products_index_860'));
      const base64 = XLSX.write(book, { bookType: 'xlsx', type: 'base64' });
      const a = document.createElement('a');
      a.setAttribute('download', i18n.t('pages_products_index_861'));
      a.href = 'data:application/vnd.ms-excel;base64,' + base64;
      a.click();
      this.exportLoading = false;
    },
    exportChuanChengData () {
      axios.get('/products/export_chuancheng').then(({ data: list }) => {
        this.chuanChengData = list;
        setTimeout(() => {
          const book = XLSX.utils.book_new();
          const s1 = XLSX.utils.table_to_sheet(this.$refs.chuanchengTable);
          XLSX.utils.book_append_sheet(book, s1, i18n.t('pages_products_index_862'));
          const base64 = XLSX.write(book, { bookType: 'xlsx', type: 'base64' });
          const a = document.createElement('a');
          a.setAttribute('download', i18n.t('pages_products_index_863'));
          a.href = 'data:application/vnd.ms-excel;base64,' + base64;
          a.click();
        }, 20);
      })
    },
    getExportColumnData (row, config) {
      const val = _.get(row, config.key);
      return config.render ? config.render(val) : val
    }
  }
}
</script>
